/**
 * @module org/locationtech/jts/io/GeoJSONWriter
 */
import { GeometryFactory } from 'jsts/org/locationtech/jts/geom';
import GeoJSONParser from './GeoJSONParser';

/**
 * Writes the GeoJSON representation of a {@link Geometry}. The
 * The GeoJSON format is defined <A
 * HREF="http://geojson.org/geojson-spec.html">here</A>.
 */
export default class GeoJSONWriter {
    constructor(geometryFactory) {
        this.geometryFactory = geometryFactory || new GeometryFactory();
        this.parser = new GeoJSONParser(this.geometryFactory);
    }

    /**
     * Converts a <code>Geometry</code> to its GeoJSON representation.
     *
     * @param {Geometry}
     *          geometry a <code>Geometry</code> to process.
     * @return {Object} The GeoJSON representation of the Geometry.
     * @memberof module:org/locationtech/jts/io/GeoJSONWriter#
     */
    write(geometry) {
        return this.parser.write(geometry);
    }
}
